import baseMixin from "../mixin";

export default {
    mixins: [baseMixin],
    data() {
        return {
            formData: {
                srcLabel: 7
            }
        };
    }
};
